.groupHeader {
  width: 100%;
}

.unreadTitle {
  font-weight: var(--ant-font-weight-strong);
}

.eventRow {
  padding: var(--ant-padding-xs) 0;
}

.eventRowUnread {
  background: var(--ant-color-primary-bg);
}

.iconCircle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  flex: none;
}
